/**
 * Performs necessary DOM updates when switching between map and list view.
 * @param {boolean} active
 */
export default function toggleMapViewInDOM(active) {
    document.getElementById('main').classList.toggle('map-view', active)
    document.documentElement.classList.toggle('noscroll', active)
}
